// @flow

import React from 'react';

import {gt} from 'app/utils/i18n';

import {documentTeamVia} from 'app/teams/selectors';
import {DetailPageGenericTeamsSidebar} from 'app/components/general/DetailPageGenericTeamsSidebar';

import type {
  BasicTeamType,
  TeamType,
  TeamMembershipType,
} from 'app/teams/types';
import {useAsyncActions} from 'app/utils/redux';

type OwnProps = {|
  id: number,
  url: string,
  canEdit: boolean,
  onClose: () => void,
  fetch: () => Promise<any>,
  teams: Array<BasicTeamType>,
  contentType: 'procedure' | 'process' | 'policy',
  team_memberships: Array<TeamMembershipType>,
|};

type DispatchProps = {|
  add: (
    BasicTeamType,
    Array<{url: string}>
  ) => (dispatch: FuncDispatch) => Promise<any>,
  remove: <T: {+team: string, +url: string}>(
    TeamType,
    {team_memberships: Array<T>}
  ) => (dispatch: FuncDispatch) => Promise<any>,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

export const DocumentTeamsSidebar = ({
  id,
  url,
  contentType,
  canEdit,
  add,
  remove,
  fetch,
  team_memberships,
  teams,
  ...other
}: Props) => {
  const actions = useAsyncActions({add, remove});

  const props = {
    objectId: id,
    objectContentType: contentType,
    objectURL: url,
    objectTeams: teams,
    addToTeam: actions.add,
    removeFromTeam: actions.remove,
    canEditObject: canEdit,
    fetchObject: fetch,
    objectTeamsMembership: team_memberships,

    itemComponentProps: (team, attached) => {
      const via = documentTeamVia(team_memberships, team);

      return {
        disableAndShowTooltipText:
          attached && via.via == 'process'
            ? gt(
                'The document was added to this team via a process %s',
                via.name
              )
            : attached && via.via == 'folder'
            ? gt(
                'The document was added to this team via a folder %s',
                via.name
              )
            : !canEdit
            ? gt('You must be a manager of this document')
            : !team.can_edit
            ? gt('Only a manager can add and remove from this team')
            : undefined,
        actionTooltip: attached
          ? contentType != 'policy'
            ? gt(
                'Remove document from this team (this will also cancel any tasks related to the team.)'
              )
            : gt('Remove document from this team.')
          : gt('Add document to this team'),
      };
    },
    ...other,
  };

  // $FlowFixMe - couldn't make Flow stop complaining about direct key in TeamMembershipType
  return <DetailPageGenericTeamsSidebar {...props} />;
};
